module.exports = __webpack_public_path__ + "776ccb437c6a7e563d6670c7b137e9db.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/icons/instagram-icon.svg
 ** module id = 208
 ** module chunks = 0
 **/